export default __webpack_public_path__ + "static/media/museum.ef27ce5c.jpg";